import React, { forwardRef, Ref } from 'react';
import classnames from 'classnames';
import { Input as AntdInput, InputRef } from 'antd';
import type { PasswordProps } from 'antd/es/input';

const PREFIX = 'music';

function _Password(props: PasswordProps, ref: Ref<InputRef>) {
  const { className, ...rstProps } = props;

  return (
    <AntdInput.Password
      className={classnames(
        `${PREFIX}-input`,
        className
      )}
      ref={ref}
      {...rstProps}
    />
  );
}

const Password = forwardRef(_Password);

export default Password;
